var redirects = [
  {
    "oldUrl": "/collections/opal/products/opal-heart-ring-celtic-jewelry-boho-89200",
    "newUrl": "/products/opal-heart-ring-celtic-jewelry-boho-89200"
  },
  {
    "oldUrl": "/collections/rings/products/celtic-queen-ring-celtic-jewelry-irish-37838",
    "newUrl": "/products/celtic-queen-ring-celtic-jewelry-irish-37838"
  },
  {
    "oldUrl": "/collections/gifts/products/scottish-gift-box-scone-gift-box-20416",
    "newUrl": "/products/scottish-gift-box-scone-gift-box-20416"
  },
  {
    "oldUrl": "/collections/gifts/products/scottish-fudge-tin-scotland-gift-box-14172",
    "newUrl": "/products/scottish-fudge-tin-scotland-gift-box-14172"
  },
  {
    "oldUrl": "/collections/gifts/products/scottish-gift-box-tea-gift-box-thistle-70418",
    "newUrl": "/products/scottish-gift-box-tea-gift-box-thistle-70418"
  },
  {
    "oldUrl": "/collections/gifts/products/irish-gift-box-tea-gift-box-ireland-75886",
    "newUrl": "/products/irish-gift-box-tea-gift-box-ireland-75886"
  },
  {
    "oldUrl": "/collections/thistle/products/thistle-earrings-celtic-jewelry-scotland-jewelry-outlander-jewelry-nature-jewelry-thistle-jewelry-wiccan-jewelry-wife-gift",
    "newUrl": "/products/thistle-earrings-celtic-jewelry-scotland-jewelry-outlander-jewelry-nature-jewelry-thistle-jewelry-wiccan-jewelry-wife-gift"
  },
  {
    "oldUrl": "/collections/celtic/products/love-knot-necklace-celtic-necklace-06695",
    "newUrl": "/products/love-knot-necklace-celtic-necklace-06695"
  },
  {
    "oldUrl": "/collections/ireland/products/celtic-knot-earrings-irish-jewelry-24779",
    "newUrl": "/products/celtic-knot-earrings-irish-jewelry-24779"
  },
  {
    "oldUrl": "/collections/ireland/products/celtic-knot-earrings-celtic-jewelry-34566",
    "newUrl": "/products/celtic-knot-earrings-celtic-jewelry-34566"
  },
  {
    "oldUrl": "/collections/ireland/products/claddagh-ring-celtic-jewelry-irish-82969",
    "newUrl": "/products/claddagh-ring-celtic-jewelry-irish-82969"
  },
  {
    "oldUrl": "/collections/dragons/products/dragon-necklace-celtic-jewelry-irish-32822",
    "newUrl": "/products/dragon-necklace-celtic-jewelry-irish-32822"
  },
  {
    "oldUrl": "/collections/slides/products/celtic-knot-ponytail-holder-celtic-39227",
    "newUrl": "/products/celtic-knot-ponytail-holder-celtic-39227"
  },
  {
    "oldUrl": "/collections/clips/products/celtic-knot-hair-clip-celtic-barrette-24531",
    "newUrl": "/products/celtic-knot-hair-clip-celtic-barrette-24531"
  },
  {
    "oldUrl": "/collections/scotland/products/scottish-gift-box-thistle-mug-scotland-46031",
    "newUrl": "/products/scottish-gift-box-thistle-mug-scotland-46031"
  },
  {
    "oldUrl": "/collections/brooch/products/rabbit-moon-pin-celtic-brooch-hare-70614",
    "newUrl": "/products/rabbit-moon-pin-celtic-brooch-hare-70614"
  },
  {
    "oldUrl": "/collections/gifts/products/scotland-gift-box-highland-cow-gift-11522",
    "newUrl": "/products/scotland-gift-box-highland-cow-gift-11522"
  },
  {
    "oldUrl": "/collections/celestial/products/heart-claddagh-necklace",
    "newUrl": "/products/heart-claddagh-necklace"
  },
  {
    "oldUrl": "/collections/claddagh/products/shanagolden-claddagh-necklace",
    "newUrl": "/products/shanagolden-claddagh-necklace"
  },
  {
    "oldUrl": "/collections/necklet/products/morna-trinity-knot-necklace",
    "newUrl": "/products/morna-trinity-knot-necklace"
  },
  {
    "oldUrl": "/collections/rings/products/celtic-spiral-amethyst-ring",
    "newUrl": "/products/celtic-spiral-amethyst-ring"
  },
  {
    "oldUrl": "/collections/mackintosh/products/rose-mackintosh-stud-earrings",
    "newUrl": "/products/rose-mackintosh-stud-earrings"
  },
  {
    "oldUrl": "/collections/dragonflies/products/dragonfly-necklace-celtic-jewelry-11503",
    "newUrl": "/products/dragonfly-necklace-celtic-jewelry-11503"
  },
  {
    "oldUrl": "/collections/butterflies/products/butterfly-necklace-celtic-jewelry-00346",
    "newUrl": "/products/butterfly-necklace-celtic-jewelry-00346"
  },
  {
    "oldUrl": "/collections/mackintosh/products/mackintosh-rose-necklace-scotland-70195",
    "newUrl": "/products/mackintosh-rose-necklace-scotland-70195"
  },
  {
    "oldUrl": "/collections/mackintosh/products/mackintosh-bracelet-celtic-jewelry-21323",
    "newUrl": "/products/mackintosh-bracelet-celtic-jewelry-21323"
  },
  {
    "oldUrl": "/collections/scotland/products/thistle-earrings-celtic-jewelry-40970",
    "newUrl": "/products/thistle-earrings-celtic-jewelry-40970"
  }
]
